module.exports = __webpack_public_path__ + "static/media/upgrade_account.63c16e2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/upgrade_account.svg
// module id = 1697
// module chunks = 0